<template>
    <v-container fluid>
        <v-layout justify-center>
            <v-flex md12>
              <DataTableLocal :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
            </v-flex>
        </v-layout>
        <UsersDialog :model="user" v-if="get_dialogMain.dialog && (get_dialogMain.type == 'create' || get_dialogMain.type == 'update')" />
        <AssifnRoleToUserDialog :model="user" v-if="get_dialogMain.dialog && get_dialogMain.type == 'role'" />
        <!--
        <UpdatePasswordUserDialog :model="user" v-if="get_dialogMain.dialog && get_dialogMain.showtype == 'password'" />
        -->
    </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableLocal from '@/components/DataTableLocal'
import UsersDialog from '@/components/dialog/catalogo/UsersDialog'
import AssifnRoleToUserDialog from '@/components/dialog/catalogo/AssifnRoleToUserDialog'
// import UpdatePasswordUserDialog from '@/components/dialogs/UpdatePasswordUserDialog'

export default {
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'libre', hidden: '' }
        ],
        titles: [
          // { text: 'Id', value: 'id', class: 'black--text' },
          { text: 'Usuario', value: 'usuario', class: 'black--text' },
          { text: 'Empleado', value: 'empleado.NombreCompleto', class: 'black--text' },
          { text: 'Correo', value: 'email', class: 'black--text' },
          { text: 'Roles', value: 'RolesAsignados', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          // { text: 'Fecha Creacion', value: 'Created', class: 'black--text' },
          // { text: 'Fecha Actualizada', value: 'Updated', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-border-color', color: 'yellow darken-3', action: 'toEditData', code: 'libre', hidden: '' },
          { title: 'Asignar Perfil', icon: 'mdi-border-color', color: 'lime lighten-1', action: 'toAssignRole', code: 'libre', hidden: '' }
        ]
      },
      footer: {
        paging: true
      }
    },
    user: {}
  }),
  components: {
    DataTableLocal,
    UsersDialog,
    AssifnRoleToUserDialog
    // UpdatePasswordUserDialog
  },
  mounted () {
    this.getUrl('empresa.list-usuarios')
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('empresa.list-usuarios')
    },
    newData (item) {
      this.user = {}
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 600, title: 'Nuevo Usuario' })
    },
    /* ========== ========== ========== ========== ========== */
    tableAction (item) {
      this[item.action](item)
    },
    toEditData (item) {
      this.user = item.item
      this.SHOW_DIALOG_MAIN({ type: 'update', with: 600, title: 'Editar Usuario' })
    },
    toAssignRole (item) {
      this.user = item.item
      this.SHOW_DIALOG_MAIN({ type: 'role', with: 700, title: 'Asignar Rol-Usuario' })
    },

    /*
    toUpdatePassword (item) {
      this.user = item.item
      this.SHOW_DIALOG_SECOUND_MAIN({ type: 'create', showtype: 'password' })
    },
    toMunicipiosAssign (item) {
      this.SET_DATA_SECOUND_MAIN(item.item)
      router.push({ name: 'ViewMunicipiosRoleAssign', params: { id: item.item.id } })
    },
    */
    ...mapActions(['getUrlServices', 'postServiceListAction']),
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServiceListAction({ url: router, data: {} })
      } else {
        this.getUrlServices()
      }
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_OBJECTS', 'SET_DATA_SECOUND_MAIN'])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objects'])
  },
  watch: {
    get_urls () {
      this.getUrl('empresa.list-usuarios')
    },
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS()
  }

}
</script>

<style>

</style>
crear curd de roles
